export const metalFabricationData = {
  themeColor: "#DA291C",

  breadcrumbs: [
    {
      text: "HOME",
      url: "/"
    },
    {
      text: "FOR PROS",
      url: null
    },
    {
      text: "INDUSTRIAL SOLUTIONS",
      url: "/industrial"
    },
    {
      text: "METAL FABRICATION",
      url: null
    }
  ],

  heroCTAs: {
    topButton: {
      text: "REQUEST SAMPLES",
      url: "/industrial/samplesrequest/"
    },
    mainButtons: [
      {
        text: "ASK A TECHNICAL SPECIALIST",
        url: "/industrial/technicalspecialist/",
        variant: "outline"
      },
      {
        text: "REQUEST A SITE ASSESSMENT",
        url: "#site-assessment-form",
        variant: "red"
      }
    ]
  },

  components: [ 
    {
      component: "cardDeck",
      variant: "vertical",
      id: "product-lines",
      eyebrow: "YOU KNOW THE WD-40® BRAND NAME —",
      title: "but do you know what it can do for your metalworking jobs?",
      body: "For over 70 years, WD-40® Brand has helped tradespeople tackle tough jobs—from cutting and grinding to protecting raw steel. The WD-40 Specialist® line delivers targeted solutions that prevent rust, reduce wear, and keep fabrication moving. With smart delivery and purpose-built formulas, it’s everything metalworkers need to get the Job Done Right®.",
      cards: [
        {
          id: "clean-degrease",
          image: "/img/industrial-page/new/Industrial Solutions - Degreasers Image.png",
          title: "CLEANERS & DEGREASERS",
          description: "Remove grease, grime, and contaminants fast",
          linkUrl: "/products/?functionality=clean-degrease"
        },
        {
          id: "lube-penetrants",
          image: "/img/industrial-page/new/metal-fabrication/Lubricants & Penetrants Image 1.png",
          title: "LUBRICANTS & PENETRANTS",
          description: "Free stuck parts and reduce friction",
          linkUrl: "/products/?functionality=lubricates%2Cpenetrate-loosen"
        },
        {
          id: "rust-solutions",
          image: "/img/industrial-page/new/Industrial Solutions - Rust Solutions Image.png",
          title: "RUST SOLUTIONS",
          description: "Stop rust and protect metal surfaces",
          linkUrl: "/products/?functionality=removes%2Clubricates%2Crestores%2Cprotects%2Cpenetrate-loosen%2Cclean-degrease"
        }
      ],
      ctaText: "BROWSE ALL INDUSTRIAL PRODUCTS",
      ctaUrl: "/products/?category=specialist"
    },
    
    {
      component: "cardDeck",
      variant: "icons",
      id: "facility-applications",
      title: "FACILITY APPLICATIONS",
      cards: [
        {
          id: "drill-rigs",
          image: "/img/industrial-page/new/metal-fabrication/Welding & Cutting Stations Icon 2.png",
          title: "Welding & Cutting Stations",
          subtitle: "Protect precision. Improve performance.",
          description: '<a href="/products/industrial_strength_degreaser/" target="_blank" rel="noopener noreferrer">WD-40 Specialist® Industrial-Strength Degreaser</a>, <a href="/products/dry-lube/" target="_blank" rel="noopener noreferrer">Dry Lube</a>, and <a href="/products/penetrating-oil-flexible-straw/" target="_blank" rel="noopener noreferrer">Penetrant with EZ-REACH®</a> help keep welding areas clean, prevent seizing on hot-threaded components, and loosen stuck fittings—delivering reliable performance in high-heat, high-demand environments. '
        },
        {
          id: "pump-compressor-stations",
          image: "/img/industrial-page/new/metal-fabrication/Tool & Equip Maintenance Area Icon 2.png",
          title: "Tool & Equipment Maintenance Areas",
          subtitle: "Keep your tools working as hard as you do. ",
          description: 'Maintain smooth, efficient operation with <a href="/products/dry-lube/" target="_blank" rel="noopener noreferrer">WD-40 Specialist® Dry Lube</a> for clean, dust-resistant lubrication, and <a href="/products/industrial_strength_degreaser/" target="_blank" rel="noopener noreferrer">Industrial-Strength Degreaser</a> or <a href="/degreaser-and-cleaner-ez-pods/" target="_blank" rel="noopener noreferrer">Degreaser & Cleaner EZ-Pods</a> for fast, effective grease removal on tools and shop equipment.'
        },
        {
          id: "electrical-control-rooms",
          image: "/img/industrial-page/new/metal-fabrication/Storage & Material Handling Icon 2.png",
          title: "Storage & Material Handling Zones",
          subtitle: "Fight rust before it starts.",
          description: 'Protect raw materials and stored components with <a href="/products/corrosion-inhibitor/" target="_blank" rel="noopener noreferrer">WD-40 Specialist® Corrosion Inhibitor</a>, and utilize <a href="/products/spray-gel/" target="_blank" rel="noopener noreferrer">Gel Lube</a> to ensure smooth, dirt-resistant movement on racks, slides, and handling systems—even in humid environments.'
        }
      ]
    },

    {
      component: "fullWidthCTA",
      id: "facility-map",
      title: "solutions to every area of your facility",
      buttons: [
        {
          text: "download facility map",
          url: "https://www.datocms-assets.com/10845/1725637043-facility-full-of-uses.pdf",
          isSecondary: false
        }
      ]
    },


    {
      component: "cardDeck",
      variant: "badges",
      id: "badges-card-deck",
      title: "Introducing<br>the WD-40 Brand<br>Job Done Right® System",
      subtitle: "Experience a comprehensive solution designed to protect your equipment at every stage.",
      body: "This end-to-end approach ensures optimal performance, reduces the risk of failures, and keeps your machinery running smoothly.",
      extraImages: [
        "/img/industrial-page/new/WD40 - PCLP Graphic_v3 1.png",
        "/img/industrial-page/new/WD-40 Specialist Line 2.png"
      ],
      cards: [
        {
          id: "prep-it",
          image: "/img/industrial-page/new/Industrial Solutions - Prep It - Image.png",
          title: "Prep It",
          description: "Start every job with thorough preparation"
        },
        {
          id: "clean-it",
          image: "/img/industrial-page/new/Industrial Solutions - Clean It - Image.png",
          title: "Clean It",
          description: "Clean your surface for optimal lubrication"
        },
        {
          id: "lube-it",
          image: "/img/industrial-page/new/Industrial Solutions - Lube It - Image.png",
          title: "Lube It",
          description: "Experience superior performance with the best lubrication products on the market"
        },
        {
          id: "protect-it",
          image: "/img/industrial-page/new/Industrial Solutions - Protect It - Image.png",
          title: "Protect It",
          description: "Safeguard your hard work with the trusted protection of the WD-40 Brand"
        }
      ]
    },

    {
      component: "cardDeck",
      variant: "products"
    },

    {
      component: "fullWidthCTA",
      id: "safety-efficiency",
      title: "SOLUTIONS TO MAXIMIZE SAFETY & EFFICIENCY",
      buttons: [
        {
          text: "SAFETY DATA SHEETS",
          url: "https://wd40company.com/partners-suppliers/safety-data-sheets/?region=USA",
          isSecondary: true
        },
        {
          text: "REQUEST SAMPLES",
          url: "/industrial/samplesrequest/",
          isSecondary: false
        }
      ]
    },
    {
      component: "NumberedStepsList",
      id: "trial-program",
      eyebrow: "PREP IT. CLEAN IT. LUBE IT. PROTECT IT.",
      title: "WD-40 BRAND JOB DONE RIGHT TRIAL PROGRAM",
      subtitle: "GET INDUSTRIAL-STRENGTH PERFORMANCE, PROVEN IN YOUR FACILITY.",
      body: "The WD-40 Specialist product line is built to handle the toughest maintenance challenges across industries. Now, with our Job Done Right Trial Program, you can put our solutions to the test—right on your floor, with your team, and your toughest jobs.",
      steps: [
        {
          number: "1",
          title: "ON-SITE ASSESSMENT",
          description: "Our experts visit your facility to understand your systems, challenges, and performance goals. From conveyor lines to electrical panels, we evaluate where you need support most."
        },
        {
          number: "2",
          title: "TAILORED RECOMMENDATIONS BY PRODUCT CATEGORY",
          description: "We match WD-40 Specialist solutions to your specific needs:",
          bulletPoints: [
            {
              title: "Cleaners & Degreasers",
              description: "Remove grease, grime, and contaminants fast"
            },
            {
              title: "Lubricants & Penetrants",
              description: "Free stuck parts and reduce friction"
            },
            {
              title: "Rust Solutions",
              description: "Stop rust and protect metal surfaces"
            }
          ]
        },
        {
          number: "3",
          title: "TRIAL IMPLEMENTATION",
          description: "We'll run a live trial in your environment to demonstrate product performance where it matters most—on the job. You'll receive a detailed Findings Report with key metrics, ROI, and measurable improvements."
        },
        {
          number: "4",
          title: "LONG-TERM OPTIMIZATION",
          description: "The trial is just the beginning. Our team supports your ongoing success with training, product guidance, and evolving solutions as your facility grows."
        }
      ]
    },
    {
      component: "site-assessment-form"
    },
    {
      component: "cardDeck",
      variant: 'faqs',
      id: "food-beverage-faqs",
      title: "FREQUENTLY ASKED QUESTIONS",
      cards: [
        {
          id: "faq-1",
          title: "How do WD-40® Brand products help protect raw metal during fabrication?",
          body: "WD-40 Brand solutions are built to protect exposed metal from flash rust and corrosion throughout the fabrication process. Products like WD-40 Specialist® Long-Term Corrosion Inhibitor form a durable, protective layer that shields steel parts during cutting, grinding, storage, or transportation."
        },
        {
          id: "faq-2",
          title: "Can WD-40® Brand products help reduce equipment wear in high-heat metalworking environments?",
          body: "Absolutely. WD-40 Specialist® lubricants, like White Lithium Grease and Dry Lube, are engineered to withstand heavy loads and high temperatures. They reduce friction on sliding surfaces, way covers, and guides—helping extend equipment life and minimize unplanned downtime in welding bays, press areas, and CNC cells."
        },
        {
          id: "faq-3",
          title: "Are WD-40 Brand Products safe to use around welding and cutting areas?",
          body: "Yes. For example, WD-40 Specialist Industrial-Strength Degreaser is great for welding prep. It removes oil and grime with nearly zero residue, helping ensure clean, reliable welds and safe work areas."
        }
      ],
      ctaText: "ASK A TECHNICAL SPECIALIST",
      ctaUrl: "/industrial/technicalspecialist/"
    }
  ],

};
